import axios from 'axios';

import buildPaginationQueryOpts from '@/shared/sort/sorts';

import { IUserStampsRedemptionRequest } from '@/shared/model/user-stamps-redemption-request.model';

const baseApiUrl = 'api/user-stamps-redemption-requests';
const baseSearchApiUrl = 'api/_search/user-stamps-redemption-requests?query=';

export default class UserStampsRedemptionRequestService {
  public search(query, paginationQuery): Promise<any> {
    return new Promise<any>(resolve => {
      axios.get(`${baseSearchApiUrl}${query}&${buildPaginationQueryOpts(paginationQuery)}`).then(function(res) {
        resolve(res);
      });
    });
  }

  public find(id: number): Promise<IUserStampsRedemptionRequest> {
    return new Promise<IUserStampsRedemptionRequest>(resolve => {
      axios.get(`${baseApiUrl}/${id}`).then(function(res) {
        resolve(res.data);
      });
    });
  }

  public retrieve(paginationQuery?: any): Promise<any> {
    return new Promise<any>(resolve => {
      axios.get(baseApiUrl + `?${buildPaginationQueryOpts(paginationQuery)}`).then(function(res) {
        resolve(res);
      });
    });
  }

  public delete(id: number): Promise<any> {
    return new Promise<any>(resolve => {
      axios.delete(`${baseApiUrl}/${id}`).then(function(res) {
        resolve(res);
      });
    });
  }

  public create(entity: IUserStampsRedemptionRequest): Promise<IUserStampsRedemptionRequest> {
    return new Promise<IUserStampsRedemptionRequest>(resolve => {
      axios.post(`${baseApiUrl}`, entity).then(function(res) {
        resolve(res.data);
      });
    });
  }

  public update(entity: IUserStampsRedemptionRequest): Promise<IUserStampsRedemptionRequest> {
    return new Promise<IUserStampsRedemptionRequest>(resolve => {
      axios.put(`${baseApiUrl}`, entity).then(function(res) {
        resolve(res.data);
      });
    });
  }
}
